import { useState } from "react"
import { getDateNow , getDateCurrentWeek , getDateCurrentMonth} from "../../../utils";

export declare type InputProps = {
    activeTab : number ;
    onChange?: (data:any) => any;
}

export const ReportSelectPeriod = ({  onChange , activeTab }: InputProps) => {
    let listData = ['امروز', 'هفته جاری', 'ماه جاری']

    const handelClick = (num: number) => {
        if(num == activeTab) return
        let data:any = {}
        if(num === 0){
            data['from'] = getDateNow();
            data['to'] = getDateNow();
        }
        else if (num == 1){
            data['from'] = getDateCurrentWeek()[0];
            data['to'] = getDateCurrentWeek()[1];
        }
        else if (num == 2){
            data['from'] = getDateCurrentMonth()[0];
            data['to'] = getDateCurrentMonth()[1];
        }
        onChange?.([data , num])
    }

    

    return (
        <div className=" w-full flex  ">
            {listData.map((item: string, index: number) =>
                <div key={index} onClick={() => handelClick(index)} className={` w-full h-[30px] rounded-lg shadow flex justify-center items-center text-[11px] cursor-pointer mx-1 ${activeTab == index ? 'bg-dayan-gray-200 text-white' :  'bg-white text-dayan-gray-200'} ${index == 0 && 'mr-0'} ${listData.length == index+1 && 'ml-0'}`}>{item}</div>
            )}
        </div>
    );
}